export const actions = {
    SET_GUEST_MODE: "SET_GUEST_MODE",
    TOGGLE_GUEST_MODE: "TOGGLE_GUEST_MODE",
};

export const setGuestMode = ( guestMode) => {
    return {
        type: actions.SET_GUEST_MODE,
        guestMode: guestMode || false,
    }
};

export const toggleGuestMode = ( toggle ) => {
    return {
        type: actions.TOGGLE_GUEST_MODE,
        guestMode: toggle,
    }
};




// WEBPACK FOOTER //
// src/client/components/site/features/profile/actions/guest.js